var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m9.647 3.475.002-.004a2.75 2.75 0 0 1 4.704.004l8.476 14.15a2.75 2.75 0 0 1-2.359 4.125H3.522a2.75 2.75 0 0 1-2.345-4.135zM12 3.647a1.25 1.25 0 0 0-1.068.6L2.47 18.375a1.25 1.25 0 0 0 1.06 1.875h16.932a1.25 1.25 0 0 0 1.075-1.865L13.069 4.25A1.25 1.25 0 0 0 12 3.647M13 16.6a1 1 0 0 1-2 0V13a1 1 0 0 1 2 0zm0-7a1 1 0 0 1-2 0V9a1 1 0 0 1 2 0z"
})));
export default SvgWarning;